import { SortingState as TableSortingState } from "@tanstack/react-table"
import { ObjectType, ObjectTypeConfig, SortingState as ListingSortingState, View } from "../../../state/listing/generic-listing"

export const getObjectTypeConfig = (objectType: ObjectType): ObjectTypeConfig => {
    try {
        const config = require(`../../../state/listing/generic-listing/column-definitions/${objectType}`)
        return config.default as ObjectTypeConfig
    } catch (e) {
        console.error(`Error: Could not find configuration for object type ${objectType}`)
        return {} as ObjectTypeConfig
    }
}

export const getDefaultSortId = (objectType: ObjectType): string => {
    const config = getObjectTypeConfig(objectType)
    const column = (config.columnDefinitions ?? []).find(column => column.defaultSort)
    return column?.sortId ?? column?.id ?? ""
}

export const getNestedSortingFilters = (objectType: ObjectType, columnId: string): {[key: string]: string } => {
    const config = getObjectTypeConfig(objectType)
    const column = (config.columnDefinitions ?? []).find(column => column.id === columnId)
    return column?.nestedSortFilters ?? {}
}

export const mapColumnIdToSortId = (objectType: ObjectType, columnId: string): string => {
    const config = getObjectTypeConfig(objectType)
    const column = (config.columnDefinitions ?? []).find(column => column.id === columnId)
    return column?.sortId ?? column?.id ?? ""
}

export const mapSortIdToColumnId = (objectType: ObjectType, sortId: string): string => {
    const config = getObjectTypeConfig(objectType)
    const column = (config.columnDefinitions ?? []).find(column => (column.sortId ?? column.id) === sortId)
    return column?.id ?? ""
}

export const mapListingSortingStateToTableSortingState = (objectType: ObjectType, listingSortingState: ListingSortingState): TableSortingState => {
    return [{ id: mapSortIdToColumnId(objectType, listingSortingState.sortField), desc: !listingSortingState.asc }]
}

export const getDefaultView = (objectType: ObjectType): View => {
    const config = getObjectTypeConfig(objectType)
    return {
        columns: (config.columnDefinitions ?? [])
            .filter(definition => definition.defaultView)
            .map(definition => {
                return {
                    attributeId: definition.id,
                    showTotal: !!definition.totalAttributes,
                }
            })
    }
}

export const doesViewIncludeIds = (view: View, ids: string[]): boolean => {
    return !!view.columns.find(column => ids.includes(column.attributeId))
}

export const COLUMNS_WITH_PAYMENT_TERM_IDS = ["paymentTermId"]
export const COLUMNS_WITH_TAX_IDS = ["taxId"]
export const COLUMNS_WITH_LABEL_IDS = ["productsLabels", "tagIds"]


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/utils.ts